import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'formlabs-web-components/Form';

import { getOccupations } from './SelectOptions';
import { sortWithLocale } from '../../../utils';
import CountryContext from '../../../context/country';

const OccupationSelect = props => {
  const { t } = useTranslation();
  const { language } = useContext(CountryContext);

  return (
    <Select {...props}>
      <option value="">– {t('Select')} –</option>
      {sortWithLocale(getOccupations(t), language).map(occupation => (
        <option key={occupation.value} value={occupation.value}>
          {occupation.text}
        </option>
      ))}
    </Select>
  );
};
OccupationSelect.defaultProps = { defaultValue: '' };
export default OccupationSelect;
